import React, { useState } from 'react';
import { CheckCircle, ChevronDown } from 'lucide-react';
import { SectionWrapper } from './ui/SectionWrapper';
import { Button } from './ui/Button';
import { motion, AnimatePresence } from 'framer-motion';
export function PriceOffer() {
  return <SectionWrapper className="bg-gradient-to-b from-white to-slate-50" data-id="element-205">
      <div className="max-w-lg mx-auto" data-id="element-206">
        <div className="bg-white rounded-2xl shadow-2xl p-8 md:p-10 border border-slate-100 text-center relative overflow-hidden" data-id="element-207">
          <div className="absolute top-0 left-0 right-0 h-2 bg-gradient-to-r from-emerald-500 to-blue-500" data-id="element-208" />

          <span className="inline-block px-3 py-1 bg-emerald-100 text-emerald-700 text-xs font-bold rounded-full mb-6 uppercase tracking-wide" data-id="element-209">
            Acceso inmediato
          </span>

          <h2 className="text-2xl font-bold text-slate-900 mb-2" data-id="element-210">
            Amazon FBA desde Cero (USA)
          </h2>

          <div className="my-8" data-id="element-211">
            <div className="text-5xl font-extrabold text-emerald-600 mb-2" data-id="element-212">
              $27.00{' '}
              <span className="text-lg text-slate-400 font-normal" data-id="element-213">USD</span>
            </div>
            <p className="text-slate-500 text-sm" data-id="element-214">
              Pago único — sin suscripciones
            </p>
          </div>

          <ul className="text-left space-y-4 mb-8 max-w-xs mx-auto" data-id="element-215">
            {['PDF descargable (60+ páginas)', 'Plantillas y checklists incluidas', 'Actualizaciones menores incluidas', 'Acceso de por vida al contenido'].map((item, i) => <li key={i} className="flex items-center gap-3 text-slate-700" data-id="element-216">
                <CheckCircle className="h-5 w-5 text-emerald-500 flex-shrink-0" data-id="element-217" />
                <span data-id="element-218">{item}</span>
              </li>)}
          </ul>

          <Button size="lg" fullWidth className="mb-4 text-lg shadow-emerald-500/25" data-id="element-219">
            Comprar ahora
          </Button>

          <p className="text-xs text-slate-400" data-id="element-220">
            Empieza hoy con un plan claro
          </p>
        </div>

        <div className="mt-8 space-y-2" data-id="element-221">
          <MiniFAQ question="¿Cómo recibo el ebook?" answer="Inmediatamente después del pago recibirás un enlace de descarga por email. El formato es PDF." data-id="element-222" />
          <MiniFAQ question="¿Puedo pagar desde cualquier país?" answer="Sí. Aceptamos pagos internacionales a través de la plataforma de pago." data-id="element-223" />
          <MiniFAQ question="¿Hay algún costo adicional?" answer="No. El precio incluye todo el contenido, plantillas y actualizaciones menores." data-id="element-224" />
        </div>
      </div>
    </SectionWrapper>;
}
function MiniFAQ({
  question,
  answer
}: {
  question: string;
  answer: string;
}) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="border-b border-slate-200 last:border-0" data-id="element-225">
      <button onClick={() => setIsOpen(!isOpen)} className="flex w-full items-center justify-between py-3 text-left text-sm font-medium text-slate-600 hover:text-emerald-600 transition-colors" data-id="element-226">
        {question}
        <ChevronDown className={`h-4 w-4 transition-transform ${isOpen ? 'rotate-180' : ''}`} data-id="element-227" />
      </button>
      <AnimatePresence data-id="element-228">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} className="overflow-hidden" data-id="element-229">
            <p className="pb-3 text-xs text-slate-500 leading-relaxed" data-id="element-230">
              {answer}
            </p>
          </motion.div>}
      </AnimatePresence>
    </div>;
}